// extracted by mini-css-extract-plugin
export default {"title":"THsInfoModal_title__uxGC-"};